/**
 * Shared helpers for building attachment download URLs.
 * Used by AttachmentsTable and VersionHistory.
 */

/**
 * Strip an ARI prefix to get the bare numeric content ID.
 * e.g. "ari:cloud:confluence::content/12345" → "12345"
 */
export const toBareContentId = (id: string): string => {
	const lastSlash = id.lastIndexOf('/');
	return lastSlash >= 0 ? id.slice(lastSlash + 1) : id;
};

/**
 * Build a download URL for an attachment on a known page.
 */
export const buildDownloadUrl = (pageId: string, fileName: string, version?: number): string => {
	if (typeof window === 'undefined') {
		return '';
	}
	const base = `${window.location.origin}/wiki/download/attachments/${pageId}/${encodeURIComponent(
		fileName,
	)}`;
	return version ? `${base}?version=${version}` : base;
};

/**
 * Build a download URL from a raw downloadPath (webui field).
 */
export const buildFallbackUrl = (downloadPath: string): string => {
	if (typeof window === 'undefined') {
		return '';
	}
	return `${window.location.origin}/wiki${downloadPath}`;
};

/**
 * Resolve the best download URL: prefer pageId-based, fall back to downloadPath.
 */
export const resolveDownloadUrl = (
	pageId: string | undefined,
	fileName: string,
	version: number | undefined,
	downloadPath: string,
): string =>
	pageId ? buildDownloadUrl(pageId, fileName, version) : buildFallbackUrl(downloadPath);
